import React from "react";

// nodejs library that concatenates classes
import classNames from "classnames";
import ReactQueryParams from 'react-query-params';

// @material-ui/core components
import {withStyles} from "@material-ui/core/styles";

// @material-ui/icons

// core components
import Header from "components/Header/Header.jsx";
import projectsPageStyle from "../../../assets/jss/material-kit-react/views/projectsPage";
import Parallax from "../../../components/Parallax/Parallax";
import HeaderLinks from "../HeaderLinks";
import {Projects, Tags} from "../../../database/dictionary";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import ProjectCard from "../Components/ProjectCard";
import Footer from "../Sections/Footer";
// import Badge from "../../../components/Badge/Badge";
// import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// import {ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, Typography} from "@material-ui/core";

class ProjectsPage extends ReactQueryParams {
    constructor(props) {
        super(props);

        const tag = this.queryParams.tag;
        this.state = {
            selectedTag: tag ? Tags[tag.toUpperCase()] : null
        }
    }

    getPageName() {
        let name = this.state.selectedTag ? this.state.selectedTag.name + " " : "";
        return name + "Projects";
    }

    render() {
        const {classes, ...rest} = this.props;
        return (
            <div className={classNames(classes.root)}>
                <Header
                    color="transparent"
                    brand="HOME"
                    rightLinks={<HeaderLinks/>}
                    fixed
                    changeColorOnScroll={{
                        height: 100,
                        color: "white"
                    }}
                    {...rest}
                />
                <Parallax small image={require("assets/img/developer-bg.jpg")}>
                    <div className={classes.container}>
                        <GridContainer justify="center">
                            <GridItem xs={12} sm={12} md={6}>
                                <h1 className={classNames(classes.title, classes.textCenter)}>{this.getPageName()}</h1>
                            </GridItem>
                        </GridContainer>
                    </div>
                </Parallax>
                <div className={classNames(classes.main)}>
                    <div className={classes.container}>
                        {/*<ExpansionPanel className={classNames(classes.filter)}>*/}
                        {/*<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} className={classes.filterTitle}>*/}
                        {/*<h4>Filters</h4>*/}
                        {/*</ExpansionPanelSummary>*/}
                        {/*<ExpansionPanelDetails className={classes.filterGroup}>*/}
                        {/*<GridContainer spacing={12} alignItems={"center"}>*/}
                        {/*<GridItem className={classes.tag} onClick={() => {*/}
                        {/*this.setState({selectedTag: null});*/}
                        {/*}}>*/}
                        {/*<Badge key={"All"}>*/}
                        {/*All*/}
                        {/*</Badge>*/}
                        {/*</GridItem>*/}
                        {/*{*/}
                        {/*[Tags.Unity, Tags.ML, Tags.AR, Tags.VR].map(item =>*/}
                        {/*<GridItem className={classes.tag} onClick={() => {*/}
                        {/*this.setState({selectedTag: item});*/}
                        {/*}}>*/}
                        {/*<Badge style={{backgroundColor: item.color}}*/}
                        {/*key={item.name}>*/}
                        {/*{item.name}*/}
                        {/*</Badge>*/}
                        {/*</GridItem>*/}
                        {/*)*/}
                        {/*}*/}
                        {/*</GridContainer>*/}
                        {/*</ExpansionPanelDetails>*/}
                        {/*</ExpansionPanel>*/}
                        <GridContainer alignItems="stretch" spacing={24} className={classes.grid}>
                            {
                                Projects.filter(project => this.state.selectedTag ? project.tags.includes(this.state.selectedTag) : true).map(item =>
                                    <GridItem xs={12} sm={12} md={6} key={item.name}>
                                        <ProjectCard item={item}/>
                                    </GridItem>
                                )
                            }
                        </GridContainer>
                    </div>
                </div>
                < Footer/>
            </div>
        )
    }
}

export default withStyles(projectsPageStyle)(ProjectsPage);


// WEBPACK FOOTER //
// ./src/views/LandingPage/pages/ProjectsPage.jsx